import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';

export default function BackButton() {
  const navigate = useNavigate();
  const location = useLocation();

  // Non mostra il pulsante sulla Home
  if (location.pathname === '/') return null;

  const handleClick = () => {
    if (location.pathname === '/main') navigate('/'); // da main → home
    else navigate(-1); // dalle altre pagine → pagina precedente
  };

  return (
    <button
      onClick={handleClick}
      style={{
        position: 'fixed',
        top: '20px',
        left: '20px',
        padding: '10px 15px',
        fontSize: '14px',
        borderRadius: '8px',
        border: 'none',
        cursor: 'pointer',
        backgroundColor: '#ff9800', // arancione stile admin
        color: 'white',
        zIndex: 1000,
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        fontWeight: 500,
        transition: 'background-color 0.3s ease',
      }}
      onMouseOver={e => (e.currentTarget.style.backgroundColor = '#fb8c00')}
      onMouseOut={e => (e.currentTarget.style.backgroundColor = '#ff9800')}
    >
      <FaArrowLeft />
      Torna indietro
    </button>
  );
}
